import React, { useCallback, useMemo, useState } from 'react';
import Typo from '../../atom/Typo';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  operationNavGroup,
  systemNavGroup,
} from '@/components/organism/SideNav/navMenus';
import SideNavItem from '@/components/atom/SideNavItem';
import Accordion from '@/components/atom/Accordion';
import { NavGroup, NavItem } from '@/components/organism/SideNav/types';
import { ScrollArea } from '@/src/components/ui/scroll-area';

function SideNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navMenus: NavGroup[] = useMemo(
    () => [
      // testNavGroup(),
      operationNavGroup(),
      systemNavGroup(),
    ],
    [],
  );

  const defaultOpenMenu = useMemo(() => {
    const currentPathName = location.pathname.split(/[/]/)[1];

    for (const menu of navMenus) {
      const foundGroup = menu.groupList.find(item =>
        item.itemList.some(
          pathItem => pathItem.path.slice(1) === currentPathName,
        ),
      );

      if (foundGroup) {
        return foundGroup?.id;
      }
    }

    return undefined;
  }, [navMenus, location]);

  const [selectedTabs, setSelectedTabs] = useState<string[]>(
    defaultOpenMenu ? [defaultOpenMenu] : [],
  );

  const handleClickNavItem = useCallback(
    (path: string) => {
      if (location.pathname === path) {
        window.location.href = path;
      } else {
        navigate(path);
      }
    },
    [location, navigate],
  );

  const renderTrigger = (label: string, icon: React.ReactNode) => {
    return (
      <div className="flex items-center gap-x-2">
        {icon}
        <Typo typoType="b16b" className="whitespace-pre text-start">
          {label}
        </Typo>
      </div>
    );
  };

  const renderContent = (itemList: NavItem[]) => {
    return (
      <ul className="flex flex-col">
        {itemList.map(({ itemLabel, path }) => {
          const currentPathName = location.pathname.split(/[/]/)[1];
          const isActive = path.slice(1) === currentPathName;

          return (
            <SideNavItem
              key={itemLabel}
              isActive={isActive}
              path={path}
              label={itemLabel}
            />
          );
        })}
      </ul>
    );
  };

  return (
    <nav className="flex min-w-[240px] flex-col gap-y-5 overflow-y-auto bg-white shadow-sectionCard">
      <ScrollArea className="px-4 py-5">
        {navMenus.map(navGroup => {
          return (
            <div key={navGroup.groupLabel}>
              <Typo typoColor="gray4" typoType="b12r">
                {navGroup.groupLabel}
              </Typo>

              {navGroup.groupList.map(({ id, label, icon, itemList }) => {
                return (
                  <Accordion
                    key={id}
                    rootProps={{
                      type: 'multiple',
                      value: selectedTabs,
                      onValueChange: e => setSelectedTabs(e),
                    }}
                    triggerProps={{
                      className: 'px-0 py-3',
                    }}
                    option={[
                      {
                        value: id,
                        trigger: renderTrigger(label, icon),
                        content: renderContent(itemList),
                      },
                    ]}
                  />
                );
              })}
            </div>
          );
        })}
      </ScrollArea>
    </nav>
  );
}

export default SideNav;
